import { Navigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { StudioAdminPermission } from "src/@types/studio-admin";
import { RootState } from "src/redux/store";
import { hasStudioAdminPermission } from "./adminStudioAccess";

type Props = {
  permission: StudioAdminPermission;
  children: React.ReactNode;
};

export default function AdminStudioPermissionGuard({ permission, children }: Props) {
  const permissions = useSelector(
    (state: RootState) => state.adminAuth.adminUser.studioPermissions,
  );

  if (!hasStudioAdminPermission(permissions, permission)) {
    return <Navigate to="/403" replace />;
  }

  return <>{children}</>;
}
